export default __webpack_public_path__ + "static/media/fink-circle.ba1cfd50.png";